<template>
  <b-modal
    id="modal-contacts"
    :ok-title="$t('Save')"
    :cancel-title="$t('Abort')"
    cancel-variant="outline-secondary"
    hideHeaderClose
    no-close-on-backdrop
    @ok.prevent="saveData"
    @cancel="resetModal"
    @show="showModal"
    @hidden="modalHidden"
    size="lg"
    centered
  >
    <b-overlay :show="show" rounded="sm">
      <b-row>
        <b-col cols="12" class="modalTitle">
          <h2 class="font-weight-bolder" v-if="!editTitle">
            {{ pinpoint.label }}
            <b-button
              v-if="pinpoint.type.editable"
              class="btn-icon rounded-circle"
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                @click="editTitle = true"
                variant="flat-primary"
              />
            </b-button>
          </h2>
          <b-form-input
            v-if="editTitle"
            type="text"
            v-model="pinpoint.label"
            maxlength="25"
            autofocus
          />
          <span>{{ $t("pin_point.insert_contact_info") }}</span>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('pin_point.Name_and_Lastname')"
            label-for="name"
          >
            <b-form-input
              id="name"
              :placeholder="$t('pin_point.Name_Lastname')"
              v-model="fields.fullname"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="role" :label="$t('pin_point.Business_role')">
            <div class="form-label-group">
              <b-form-input
                id="role"
                :placeholder="$t('pin_point.business_placeholder')"
                v-model="fields.business_role"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('pin_point.phone_number')"
            label-for="phone-number"
          >
            <b-form-input
              id="phone-number"
              :placeholder="$t('pin_point.phone_number')"
              v-model="fields.telephone"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('pin_point.whatsapp_number')"
            label-for="whatsapp-number"
          >
            <b-form-input
              id="whatsapp-number"
              :placeholder="$t('pin_point.phone_number')"
              v-model="fields.whatsapp"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="mc-email"
            :label="$t('pin_point.Contact_email')"
          >
            <div class="form-label-group">
              <b-form-input
                id="mc-email"
                type="email"
                :placeholder="$t('email')"
                v-model="fields.email"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="privacy"
            :label="$t('pin_point.Privacy_policy_url')"
          >
            <div class="form-label-group">
              <b-form-input
                id="privacy"
                :placeholder="$t('pin_point.privacy_placeholder')"
                v-model="fields.privacy_policy_url"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6" class="input-form-style">
          <b-form-group :label="$t('pin_point.Contact_image')">
            <b-form-file
              v-model="file"
              :placeholder="$t('any_file_select')"
              accept=".jpg, .png"
              @input="openEditorPreview(file, 'contacts')"
            />
          </b-form-group>
          <b-img
            :src="preview_contacts"
            id="preview-contacts"
            class="preview-img"
          ></b-img>
        </b-col>
      </b-row>
      <b-row>
        <icon-selector
          v-if="pinpoint.type.editable"
          v-model="icon"
        ></icon-selector>
        <b-col cols="12" class="pin_hide">
          <footer-pin-point v-model="hide_pinpont"></footer-pin-point>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BModal,
  BFormFile,
  BImg,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, integer } from "@validations";
import Ripple from "vue-ripple-directive";
import FooterPinPoint from "./footer";
import IconSelector from "./icon-selector";

import { updatePinpoint } from "@api/pinpoint";

export default {
  props: ["pinpoint"],
  name: "pin-point-contacts",
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BButton,
    BModal,
    BFormFile,
    BImg,
    BOverlay,
    FooterPinPoint,
    IconSelector,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      hide_pinpont: !this.pinpoint.active,
      fields: { ...this.pinpoint.fields },
      file: null,
      preview_contacts: null,
      show: false,
      editTitle: false,
      icon: this.pinpoint.icon,
    };
  },
  methods: {
    showModal() {
      if (this.pinpoint.fields.image) {
        this.preview_contacts = this.pinpoint.fields.image.url;
      }
    },
    saveData() {
      const $this = this;
      this.show = true;
      let formData = new FormData();
      formData.append("label", $this.pinpoint.label);
      formData.append("email", $this.fields.email);
      formData.append("whatsapp", $this.fields.whatsapp);
      formData.append("telephone", $this.fields.telephone);
      formData.append("fullname", $this.fields.fullname);
      formData.append("business_role", $this.fields.business_role);
      formData.append("privacy_policy_url", $this.fields.privacy_policy_url);
      if ($this.file) {
        formData.append("image", $this.file);
      }
      formData.append("icon", $this.icon);
      formData.append("active", $this.hide_pinpont ? 0 : 1);
      updatePinpoint($this.pinpoint.id, formData)
        .then((data) => {
          this.$emit("onSave");
          this.$bvModal.hide("modal-contacts");
          this.show = false;
        })
        .catch((error) => {
          console.log(error);
          this.show = false;
        });
    },
    openEditorPreview(file, type) {
      this.$emit("open_editor", file, type);
    },
    emptyField() {
      this.file = null;
    },
    resetModal() {
      this.$bvModal.hide("modal-contacts");
      this.fields = { ...this.pinpoint.fields };
      this.hide_pinpont = !this.pinpoint.active;
      this.icon = this.pinpoint.icon;
      this.file = null;
    },
    modalHidden() {
      this.editTitle = false;
    },
  },
};
</script>

<style>
.preview-img {
  width: 400px;
}
</style>
